<template>

  <div class="comments">
    <!-- 页头 征友条件 -->
    <van-row>
      <van-col span="22" offset="1">
        <!-- 你希望TA是一个什么样的人？ -->
        <van-col span="24" class="my_personals_conditions_title">{{ $t('column.What_is_ta_like')}}</van-col>
        <!-- 征友条件 -->
        <van-col span="24" class="my_personals_conditions_div">
          <van-col span="24" class="my_information_type">
            <van-cell  :title="$t('user.Location')" @click="centerDialogVisible1 = true" :value="address" is-link/>
            <van-action-sheet v-model="centerDialogVisible1">
              <van-picker
                safe-area-inset-bottom
                :title="$t('user.Location')"
                show-toolbar
                :columns="address_array"
                @confirm="onConfirmcity"
                @cancel="onChangecitys"
                :confirm-button-text="$t('btn.submit')"
                :cancel-button-text="$t('btn.cancel')"
              />
            </van-action-sheet>
          </van-col>
          <van-col span="24" class="my_information_type">
            <van-cell :title="$t('user.ages')" @click="centerDialogVisible2 = true" :value="age | getage(this,$t) " is-link/>
            <van-action-sheet v-model="centerDialogVisible2">
              <van-picker
                safe-area-inset-bottom
                :title="$t('user.ages')"
                show-toolbar
                :columns = 'age_array'
                @confirm = 'onConfirmAge'
                @cancel = 'onChangeAges'
                :confirm-button-text="$t('btn.submit')"
                :cancel-button-text="$t('btn.cancel')"
              />
            </van-action-sheet>
          </van-col>
        </van-col>
        <van-col span="24" class="my_information_type_center">({{ $t('column.Recommend_opposite_sex')}})</van-col>
        <van-col span="18" offset="3" class="my_information_type_btn">
          <van-button type="primary" size="large" class="my_information_btn" @click="personals_save" safe-area-inset-bottom>{{ $t('btn.preservation')}}</van-button>
        </van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  import '@/assets/css/style.css'
  import axios from 'axios'
  import { Toast } from 'vant';
  export default {
    filters: {
      getage(age,t){
        return age ? age + t.$t('user.Age') : ''
      }
    },
    data() {
      return {
        centerDialogVisible1: false,
        centerDialogVisible2: false,
        address: this.$t('user.Location'),
        age: '',
        address_array :[],
        age_array:[],
      };
    },
    created: function() {
      this.get_address_array()
      this.convert();
      document.title = this.$t('title.personals_conditions')
    },
    methods: {
      get_address_array() {
        this.address_array = []
        // 获取地址
        this.address_array.push(this.$t('other.unlimited'))
        const appData = require('../../city.json') // 加载本地数据文件
        for(let i= 0;i< appData.length; i++){
          this.address_array.push(appData[i].areaName)
        }
      },
      onConfirmcity(picker) {
        this.address = picker
        this.centerDialogVisible1 = false
      },
      onConfirmAge(age) {
        this.age = age
        this.centerDialogVisible2 = false
      },
      onChangecitys() {
        this.centerDialogVisible1 = false
      },
      onChangeAges () {
        this.centerDialogVisible2 = false
      },
      convert() {
           const ages=[];
            ages.push(this.$t('other.unlimited'));
           for(let i=18; i<=65 ; i++){
             ages.push(i);
           }
           this.age_array = ages
           const uid = this.$route.query.uid;
           const token = this.$route.query.token;
          axios.get(this.baseUrlApi+"mapi/public/index.php/api/User_api/vue_get_user_information",{ params:{ uid:uid,token:token }}).then(res =>{
             if(res.data.code == 1){
               if(res.data.data.personals_address){
                 this.address = res.data.data.personals_address
               }
                if(res.data.data.personals_age){
                  this.age = res.data.data.personals_age
                }
             }else{
               Toast(this.$t('Tips.login_timeout'));
             }
          })
      },
      personals_save(){
        // 保存
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        let address = '';
        if(!this.address){
          Toast(this.$t('Tips.Place_friend_seeking'))
          return false
        }
        address = this.address
        if(this.address === this.$t('other.unlimited')){
          address = 'ALL';
        }
        if(!this.age){
          Toast(this.$t('Tips.Age_friend_seeking'))
          return false
        }
        axios.get(this.baseUrlApi+"mapi/public/index.php/api/User_api/personals_post",{ params:{ uid:uid,token:token,address: address,age: this.age }}).then(res =>{
          Toast(res.data.msg);
          if(res.data.code == 1){
            console.log(res)
            if (res.data.status === 1) {
              window.location.href="bogo://personals_jump";
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/personals_conditions.vue